// extracted by mini-css-extract-plugin
export var custom = "b_k";
export var gap_200 = "b_g";
export var icon = "b_j";
export var prevSection = "b_h";
export var section = "b_d";
export var separator = "b_f";
export var statePrivacy = "b_b";
export var table = "b_c";